import translation from 'store/translation';

export function useTranslation() {
  return translation;
}
